<template>
	<div class="dw-page">
		<div class="dw-page__download">
			<h2 class="dw-page__title">JOBSHEET & COMBINE PRINT (ADMIN)</h2>
			<DownloadTable></DownloadTable>
			<DownloadReq></DownloadReq>
			<div class="dw-page__divider"></div>
		</div>
		<div class="dw-page__redo-wrap">
			<ItemRedoInput></ItemRedoInput>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import DownloadTable from "../components/download/Download-table.vue";
import ItemRedoInput from "../components/download/Item-redo-input.vue";
//import ItemRedoLog from "../components/download/Item-redo-log.vue";
import DownloadReq from "../components/download/Download-req.vue";

export default Vue.extend({
	name: "Download",
	components: {
		DownloadReq,
		DownloadTable,
		ItemRedoInput,
		//ItemRedoLog
	}
});
</script>

<style lang="scss" scoped>
.dw-page {
	padding: 20px 0;

	&__title {
		text-align: center;
		font-weight: bold;
		line-height: 27px;
		margin-bottom: 41px;
		font-size: 22px;
	}

	&__divider {
		background-color: $border-color;
		margin: 50px 0;
		height: 2px;
		width: 100%;
	}

	&__redo-wrap {
		display: flex;
		justify-content: center;
	}

	&__redo-side {
		padding: 0 30px;
	}
}
</style>